// import app from '@/main';
import { fromShortToLong, fromLongToShort } from '@/components/shared/languageCodes';
import i18n from '@/lang/lang';
import defaultState from './state';

// import axios from 'axios';
const SET_USER_SELECTED_LANGUAGE = async (state, lang) => {
  let longLang = '';
  if (lang && (lang.length == 2 || lang.length == 3)) {
    longLang = fromShortToLong[lang];
  } else if (lang) {
    longLang = lang;
  } else {
    longLang = fromShortToLong.en;
  }
  state.userSelectedLanguage = longLang;
  i18n.locale = longLang;
  const html = document.documentElement;
  const englishSites = ['zh', 'uz', 'ky'];
  const splittedLongLang = longLang.split('_')[0];
  html.setAttribute('lang', englishSites.includes(splittedLongLang) ? 'en' : splittedLongLang);

  // set wcag narrator language
  let shortLang = '';
  if (lang && (lang.length == 2 || lang.length == 3)) {
    shortLang = fromLongToShort[lang];
  } else if (lang) {
    shortLang = lang;
  } else {
    shortLang = 'en';
  }

  state.narratorLanguage = shortLang;
};

const SET_SELECTED_LEARNED_LANGUAGE = async (state, lang) => {
  state.selectedLearnedLanguage = lang;
  window.$cookies.set('learned-language', lang, null, '/', null);
};

const SET_OVERWRITE_BROWSER_LANGUAGE_PERSISTED = async (state, value) => {
  state.userOverwriteBrowserLanguagePersisted = value;
};

const SET_USER_SELECTED_LEVEL = (state, level) => {
  state.userSelectedLevel = level;
};

const SET_USER_SELECTED_GOAL = (state, goal) => {
  state.userSelectedGoal = goal;
};

const SET_LESSON_SOUND_ENABLED = (state, soundEnabled) => {
  state.lesson.soundEnabled = soundEnabled;
};

const SET_LESSON_SLOW_SOUND_ENABLED = (state, enabled) => {
  state.lesson.needSlowSound = enabled;
};

const SET_LESSON_MOTIVATION_ENABLED = (state, enabled) => {
  state.lesson.needMotivation = enabled;
};

const SET_NOTIFICATION_ENABLED = (state, payload) => {
  state.isNotificationsEnabled = payload;
};

const SET_USER_SETTINGS = (state, { id, value }) => {
  state.userSettings[id] = value;
};

const SET_ALL_USER_SETTINGS = (state, userSettings) => {
  state.userSettings = userSettings;
};

const SET_TEACH_BOT_SPEED = (state, speed) => {
  state.teachBotSpeed = speed;
};

const START_FROM_CLASS = (state, value) => {
  state.startFromClass = value;
};

const DESTROY = (state) => {
  Object.keys(defaultState).forEach((key) => {
    if (!['userSelectedLanguage', 'windowWidthMobile'].includes(key)) {
      state[key] = defaultState[key];
    }
  });
};

const SET_PAGE_NOT_FOUND = (state, value) => {
  state.isPageNotFound = value;
};

const SET_LAST_LEARNED_CARD = (state, value) => {
  state.needLastLearnedCard = value;
};

const SET_PRO_POPUP_TYPE = (state, value) => {
  state.proPopupType = value;
};

const SET_IS_NEXUS_USER = (state, value) => {
  state.isNexusUser = value;
};

const SET_LAST_ROUTE = (state, value) => {
  state.lastRoute = value;
};

const SET_DKT_OPTIONS = (state, options) => {
  const defaultStateOptions = {
    classId: undefined,
    assignmentId: undefined,
    dktAssignmentId: undefined,
    lessonId: undefined,
    needToSaveOptions: false,
    fromDkt: false,
  };
  let newValue = options;
  const oldOptions = window.sessionStorage.getItem('dktOptions');
  if (oldOptions) {
    newValue = {
      ...defaultStateOptions,
      ...JSON.parse(oldOptions),
      ...options,
    };
  } else {
    newValue = { ...defaultStateOptions, ...options };
  }
  window.sessionStorage.setItem('dktOptions', JSON.stringify(newValue));
  state.dktOptions.fromDkt = newValue.fromDkt;
  state.dktOptions.classId = newValue.classId;
  state.dktOptions.needIntroScreen = newValue.needIntroScreen;
};

const SET_MOBILE_SUPPORT_MODAL_STATUS = (state, value) => {
  state.mobileSupportModalStatus = value;
};

const SET_INVALIDATION_STATUS = (state, value) => {
  state.invalidationIsRunning = value;
};

const SET_WINDOW_WIDTH_MOBILE = (state, value) => {
  state.windowWidthMobile = value;
};
const SET_WINDOW_WIDTH = (state, value) => {
  state.windowWidth = value;
};

const SET_WCAG_SETTING = (state, object) => {
  const currentWCAGSettings = state.wcag;
  state.wcag = { ...currentWCAGSettings, ...object };
};

const SET_IS_KH_USER = (state, value) => {
  state.isKHUser = value;
};

export default {
  SET_OVERWRITE_BROWSER_LANGUAGE_PERSISTED,
  SET_SELECTED_LEARNED_LANGUAGE,
  SET_USER_SELECTED_LANGUAGE,
  SET_USER_SELECTED_LEVEL,
  SET_USER_SELECTED_GOAL,
  SET_LESSON_SOUND_ENABLED,
  SET_NOTIFICATION_ENABLED,
  SET_USER_SETTINGS,
  SET_ALL_USER_SETTINGS,
  SET_TEACH_BOT_SPEED,
  DESTROY,
  SET_LESSON_SLOW_SOUND_ENABLED,
  SET_LESSON_MOTIVATION_ENABLED,
  START_FROM_CLASS,
  SET_PAGE_NOT_FOUND,
  SET_LAST_LEARNED_CARD,
  SET_PRO_POPUP_TYPE,
  SET_IS_NEXUS_USER,
  SET_LAST_ROUTE,
  SET_DKT_OPTIONS,
  SET_INVALIDATION_STATUS,
  SET_WINDOW_WIDTH_MOBILE,
  SET_WINDOW_WIDTH,
  SET_MOBILE_SUPPORT_MODAL_STATUS,
  SET_WCAG_SETTING,
  SET_IS_KH_USER,
};
